module.exports = __webpack_public_path__ + "static/media/info-circle.a443834d.svg";